<mat-toolbar color="primary">
    <span class="title-center">{{title}}</span>
</mat-toolbar>
<form [formGroup]="overrideUser" class="content" fxLayout="column"
    fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px">
    <mat-card fxLayout="column">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <input type="text" matInput placeholder="Empoyee Id"
                    formControlName="EmpId" [readonly]="true">
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput placeholder="Department Name"
                    formControlName="DepartmentName" [readonly]="true">
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <input type="text" matInput placeholder="First Name"
                    formControlName="FirstName" [readonly]="true">
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput placeholder="Last Name"
                    formControlName="LastName" [readonly]="true">
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <input type="text" matInput placeholder="Job Title"
                    formControlName="Title" [readonly]="true">
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput placeholder="Email"
                    formControlName="Email" [readonly]="true">
            </mat-form-field>
        </div>
    </mat-card>
    <mat-card fxLayout="column">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <mat-select placeholder="Manager CA"
                    formControlName="managerCA">
                    <mat-option value="">--</mat-option>
                    <mat-option *ngFor="let managerCA of MGList"
                        [value]="managerCA.EmpId">{{managerCA.EmpName}}</mat-option>
                    <!-- <mat-option *ngFor="let managerCA of TestList" [value]="managerCA.EmpId">{{managerCA.EmpName}}</mat-option> -->
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="Manager CC"
                    formControlName="managerCC">
                    <mat-option value="">--</mat-option>
                    <mat-option *ngFor="let managerCC of MGList"
                        [value]="managerCC.EmpId">{{managerCC.EmpName}}</mat-option>
                    <!-- <mat-option *ngFor="let managerCC of TestList" [value]="managerCC.EmpId">{{managerCC.EmpName}}</mat-option> -->
                </mat-select>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <mat-select placeholder="Director" formControlName="director">
                    <mat-option value="">--</mat-option>
                    <mat-option *ngFor="let director of SM_ECList"
                        [value]="director.EmpId">{{director.EmpName}}</mat-option>
                    <!-- <mat-option *ngFor="let director of TestList" [value]="director.EmpId">{{director.EmpName}}</mat-option> -->
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="VP-CR&CA" formControlName="VP_CR_CA">
                    <mat-option value="">--</mat-option>
                    <mat-option *ngFor="let VP_CR_CA of SM_ECList"
                        [value]="VP_CR_CA.EmpId">{{VP_CR_CA.EmpName}}</mat-option>
                    <!-- <mat-option *ngFor="let VP_CR_CA of TestList" [value]="VP_CR_CA.EmpId">{{VP_CR_CA.EmpName}}</mat-option> -->
                </mat-select>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <mat-select placeholder="LOB-VP1" formControlName="LOB_VP1">
                    <mat-option value="">--</mat-option>
                    <mat-option *ngFor="let LOB_VP of SM_ECList"
                        [value]="LOB_VP.EmpId">{{LOB_VP.EmpName}}</mat-option>
                    <!-- <mat-option *ngFor="let LOB_VP of TestList" [value]="LOB_VP.EmpId">{{LOB_VP.EmpName}}</mat-option> -->
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="LOB-VP2" formControlName="LOB_VP2">
                    <mat-option value="">--</mat-option>
                    <mat-option *ngFor="let LOB_VP of SM_ECList"
                        [value]="LOB_VP.EmpId">{{LOB_VP.EmpName}}</mat-option>
                    <!-- <mat-option *ngFor="let LOB_VP of TestList" [value]="LOB_VP.EmpId">{{LOB_VP.EmpName}}</mat-option> -->
                </mat-select>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <mat-select placeholder="CP/CEO" formControlName="CP_CEO">
                    <mat-option value="">--</mat-option>
                    <mat-option *ngFor="let CP_CEO of ECList"
                        [value]="CP_CEO.EmpId">{{CP_CEO.EmpName}}</mat-option>
                    <!-- <mat-option *ngFor="let CP_CEO of TestList" [value]="CP_CEO.EmpId">{{CP_CEO.EmpName}}</mat-option> -->
                </mat-select>
            </mat-form-field>

        </div>
    </mat-card>

    <div class="buttons" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center
        center">
        <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
        <button *ngIf="isEditMode" mat-raised-button (click)="onDelete()"
            color="warn">Delete</button>
        <button *ngIf="isEditMode" mat-raised-button (click)="onUpdate()"
            color="primary">Update</button>
        <button *ngIf="!isEditMode" mat-raised-button (click)="onSubmit()"
            color="primary" [disabled]="overrideUser.invalid">Submit</button>
    </div>
</form>